module.exports = __webpack_public_path__ + "static/media/Mapa-Rio Grande do Sul.fde83792.svg";